//---------------------------------------------------
//  Nom du fichier : _i18n.js 
//
//  Description: Fichier qui sert de faire la traduction pour toutes nos pages
//               Utilise les fichier public/locales/ fr ou en /translation.json
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

//https://react.i18next.com/latest/i18next-instance

i18n
  .use(HttpBackend) // charge les fichiers de traduction
  .use(LanguageDetector) // détecte la langue du navigateur
  .use(initReactI18next) // connecte à React
  .init({
    fallbackLng: 'en', // langue par défaut si rien trouvé
    debug: false,
    interpolation: {
      escapeValue: false, // React échappe déjà par défaut
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // structure des fichiers
    },
  });

export default i18n;
